<div class="rate-table">
  <div class="rate-table__col rate-table__col--labels">
    <div class="rate-table__cell rate-table__cell--spacer">&nbsp;</div>
    <div class="rate-table__cell rate-table__cell--row-label">Base</div>

    @if (urgentRate) {
      <div class="rate-table__cell rate-table__cell--row-label">Urgent</div>
    }
  </div>

  <div class="rate-table__col">
    <div class="rate-table__cell rate-table__cell--header">Hourly</div>
    <div class="rate-table__cell">{{ baseRate | currency }}</div>

    @if (urgentRate) {
      <div class="rate-table__cell">{{ urgentRate | currency }}</div>
    }
  </div>

  <div class="rate-table__col">
    <div class="rate-table__cell rate-table__cell--header">+ Diff.</div>
    <div class="rate-table__cell">{{ differentialRate | currency }}</div>

    @if (urgentRate) {
      <div class="rate-table__cell">{{ differentialRate | currency }}</div>
    }
  </div>

  <div class="rate-table__col">
    <div class="rate-table__cell rate-table__cell--header">Total</div>
    <div class="rate-table__cell rate-table__cell--total">
      {{ baseTotal | currency }}
    </div>

    @if (urgentRate) {
      <div class="rate-table__cell rate-table__cell--total">
        {{ urgentTotal | currency }}
      </div>
    }
  </div>
</div>
